/**
 * Les petites règles d'affichage de la conciergerie, partagées par le
 * back-office et l'espace formateur. Recopiées d'un écran à l'autre, elles
 * avaient déjà divergé (couleurs d'icônes, accents dans la recherche).
 */

/** Minuscules sans accents : « dupont » doit trouver « DUPONT », « elodie » « Élodie ». */
export function normaliserRecherche(valeur) {
  return String(valeur || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()
}

/**
 * Le nom d'un formateur, ou son adresse. Un compte ouvert par la conciergerie
 * n'a souvent NI nom NI structure — personne ne les a saisis : l'adresse est
 * alors la seule chose qui le désigne, et elle suffit.
 */
export function nomFormateur(formateur) {
  const f = formateur || {}
  if (f.type === 'organisme' && f.nomStructure) return f.nomStructure
  const complet = [f.prenom, f.nom].filter(Boolean).join(' ').trim()
  return complet || f.nomStructure || f.email || 'Destinataire'
}

const TYPES_FICHIER = [
  { test: (m) => m === 'application/pdf', icone: 'fas fa-file-pdf', couleur: 'var(--color-danger)' },
  { test: (m) => m.startsWith('image/'), icone: 'fas fa-file-image', couleur: 'var(--color-info)' },
  { test: (m) => m.includes('word'), icone: 'fas fa-file-word', couleur: 'var(--color-info)' },
  { test: (m) => m.includes('sheet') || m.includes('excel') || m === 'text/csv', icone: 'fas fa-file-excel', couleur: 'var(--color-success)' },
  { test: (m) => m.includes('presentation') || m.includes('powerpoint'), icone: 'fas fa-file-powerpoint', couleur: 'var(--color-warning)' },
  { test: (m) => m.includes('zip'), icone: 'fas fa-file-zipper', couleur: 'var(--color-text-tertiary)' },
]

/** L'icône et la couleur d'un type de fichier, comme dans un explorateur. */
export function typeFichier(mimeType) {
  const mime = String(mimeType || '')
  const trouve = TYPES_FICHIER.find((type) => type.test(mime))
  return trouve
    ? { icone: trouve.icone, couleur: trouve.couleur }
    : { icone: 'fas fa-file-lines', couleur: 'var(--color-text-tertiary)' }
}

/**
 * Ce que la suppression d'un dossier emporte, dit avant le clic — la même
 * phrase depuis la liste et depuis la fiche. Honnête sur ce qui se passe
 * VRAIMENT : les formateurs cessent de voir le dossier, mais les fichiers ne
 * sont pas détruits sur le stockage (la suppression est réversible côté serveur).
 */
export function consequencesSuppressionDossier({ nbFichiers = 0, nbAcces = 0 } = {}) {
  const consequences = ['Le dossier disparaît de la conciergerie.']
  if (nbAcces > 0) {
    consequences.push(
      `${nbAcces} accès ${nbAcces > 1 ? 'sont fermés' : 'est fermé'} : le dossier quitte l’espace des formateurs concernés.`
    )
  }
  if (nbFichiers > 0) {
    consequences.push(
      `${nbFichiers} fichier${nbFichiers > 1 ? 's ne sont plus consultables' : ' n’est plus consultable'}.`
    )
  }
  return consequences
}
